import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./styles/header.css";
import "./styles/navbar.css";
import "./styles/hero.css";
import "./styles/about.css";
import "./styles/responsive.css";
import "./styles/footer.css";
import "./styles/services.css";

import Header from "./components/Header";
import Navbar from "./components/Navbar";
import HomePage from "./components/HomePage";
import AboutPage from "./components/AboutPage";
import ServicesPage from "./components/ServicesPage";
import ContactPage from "./components/ContactPage";

import BurgerMenu from "./components/BurgerMenu"; // New burger component

function App() {
  const [menuOpen, setMenuOpen] = useState(false);

  // Hide contacts, show burger based on screen width (CSS does the hiding)
  return (
    <Router>
      <Header
        right={
          <>
            <div className="header__contacts">
              <div className="header__contact">
                <span className="header__icon">📞</span>
                <span>+61 426 533 333</span>
              </div>
              <div className="header__contact">
                <span className="header__icon">✉️</span>
                <span>info@carenestservicesau.com.au</span>
              </div>
            </div>
            <BurgerMenu menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
          </>
        }
      />
      <Navbar menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
    </Router>
  );
}

export default App;
